import { LogoSpotify, cssColorValue, screenMdMin, screenSmMax, spacer72, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
import { Link } from '../Link/Link';
import { trackCat } from './constants';
const LogoWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: ${spacer72};
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  width: 15%;
  @media (max-width: ${screenSmMax}) {
    width: 100%;
  }
`;
const StyledLogo = styled(LogoSpotify) `
  color: ${props => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.primaryText) !== null && _b !== void 0 ? _b : cssColorValue('textBase'); }};
  fill: ${props => { var _a, _b; return (_b = (_a = props === null || props === void 0 ? void 0 : props.colors) === null || _a === void 0 ? void 0 : _a.primaryText) !== null && _b !== void 0 ? _b : cssColorValue('textBase'); }};
  height: 26px;
  @media (min-width: ${screenMdMin}) {
    height: 36px;
  }
`;
export const Logo = ({ colors }) => {
    return (React.createElement(LogoWrapper, null,
        React.createElement(Link, { openInNewWindow: true, href: "https://www.spotify.com", trackingAttributes: [trackCat, 'Logo'], dataTestId: "footer-logo" },
            React.createElement(StyledLogo, { colors: colors }))));
};
//# sourceMappingURL=Logo.js.map